<template>
  <div class="t-lk-events">
    <div class="t-lk-container">
      <lk-title-link-cmp
        v-animation:bottom.delay
        :title="$root.staticText.lk.eventsTitle"
        :link="'/events'"
        :name="$root.staticText.lk.eventsAll"
      ></lk-title-link-cmp>
      <h1 class="visually-hidden">{{ $root.staticText.lk.eventsTitle }}</h1>

      <div class="t-lk-events__container">
        <div v-if="events && events.length === 0" v-animation:bottom.delay class="t-lk-events__empty">
          {{ $root.staticText.lk.empty }}
        </div>
        <div v-animation:bottom.delay v-for="(item, index) in events" class="t-lk-events__item" :class="{ _first: index === 0 }">
          <div class="t-lk-events__left">
            <div class="t-lk-events__row">
              <div class="t-lk-events__category">{{ item.category }}</div>
              <div class="t-lk-events__date">{{ item.date }}</div>
              <template v-if="isMobile">
                <svg
                  class="t-lk-events__recommendation"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 10H18.764C19.1049 10 19.4401 10.0871 19.7378 10.2531C20.0355 10.4191 20.2859 10.6584 20.4651 10.9484C20.6444 11.2383 20.7465 11.5692 20.7619 11.9098C20.7773 12.2503 20.7054 12.5891 20.553 12.894L17.053 19.894C16.8869 20.2265 16.6314 20.5061 16.3152 20.7014C15.999 20.8968 15.6347 21.0002 15.263 21H11.246C11.083 21 10.92 20.98 10.761 20.94L7 20M14 10V5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3H11.905C11.405 3 11 3.405 11 3.905C11 4.619 10.789 5.317 10.392 5.911L7 11V20M14 10H12M7 20H5C4.46957 20 3.96086 19.7893 3.58579 19.4142C3.21071 19.0391 3 18.5304 3 18V12C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10H7.5"
                    stroke="#00b0bd"
                    stroke-width="1.68"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
              <template v-else>
                <btn-green-cmp
                  v-if="item.isRecommendation"
                  :link="''"
                  :name="$root.staticText.lk.eventsRecommendation"
                  class="t-lk-events__recommendation"
                >
                </btn-green-cmp>
              </template>
            </div>
            <div class="t-lk-events__name t-clamp-3">{{ item.name }}</div>
            <div class="t-lk-events__row _top">
              <div class="t-lk-events__img">
                <img v-if="item.img" :src="item.img" alt="" />
              </div>
              <div class="t-lk-events__invite" @click="modalType_inviteOpen({ id: item.id })">
                <template v-if="isMobile">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18 9V12M18 12V15M18 12H21M18 12H15M15 21V20C15 18.4087 14.3679 16.8826 13.2426 15.7574C12.1174 14.6321 10.5913 14 9 14C7.4087 14 5.88258 14.6321 4.75736 15.7574C3.63214 16.8826 3 18.4087 3 20V21M13 7C13 8.06087 12.5786 9.07828 11.8284 9.82843C11.0783 10.5786 10.0609 11 9 11C7.93913 11 6.92172 10.5786 6.17157 9.82843C5.42143 9.07828 5 8.06087 5 7C5 5.93913 5.42143 4.92172 6.17157 4.17157C6.92172 3.42143 7.93913 3 9 3C10.0609 3 11.0783 3.42143 11.8284 4.17157C12.5786 4.92172 13 5.93913 13 7Z"
                      stroke="#00b0bd"
                      stroke-width="1.68"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
                <template v-else>
                  {{ $root.staticText.lk.eventsInvite }}
                </template>
              </div>
              <a v-if="!item.isAdded" :href="item.ics" @click="item.isAdded = true" class="t-lk-events__add">
                <template v-if="(isTablet && index > 0) || isMobile">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.26676 7.33343V3.6001M15.7334 7.33343V3.6001M7.33343 11.0668H16.6668M10.8001 20.4001H5.46676C4.97169 20.4001 4.4969 20.2034 4.14683 19.8534C3.79676 19.5033 3.6001 19.0285 3.6001 18.5334V7.33343C3.6001 6.83836 3.79676 6.36357 4.14683 6.0135C4.4969 5.66343 4.97169 5.46676 5.46676 5.46676H18.5334C19.0285 5.46676 19.5033 5.66343 19.8534 6.0135C20.2034 6.36357 20.4001 6.83836 20.4001 7.33343V12.0001"
                      stroke="#4D556D"
                      stroke-width="1.68"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8657 22.2002V18.1057V14.4002"
                      stroke="#4D556D"
                      stroke-width="1.68"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.7656 18.2998H17.6711H13.9656"
                      stroke="#4D556D"
                      stroke-width="1.68"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
                <template v-else>
                  {{ $root.staticText.lk.eventsAdd }}
                </template>
              </a>
              <a
                v-else
                :href="item.ics"
                class="t-lk-events__add _delete"
                @mouseenter="visibleDelete = index"
                @mouseleave="visibleDelete = -1"
                @click="item.isAdded = false"
              >
                <template v-if="(isTablet && index > 0) || isMobile">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.26676 7.33343V3.6001M15.7334 7.33343V3.6001M7.33343 11.0668H16.6668M10.8001 20.4001H5.46676C4.97169 20.4001 4.4969 20.2034 4.14683 19.8534C3.79676 19.5033 3.6001 19.0285 3.6001 18.5334V7.33343C3.6001 6.83836 3.79676 6.36357 4.14683 6.0135C4.4969 5.66343 4.97169 5.46676 5.46676 5.46676H18.5334C19.0285 5.46676 19.5033 5.66343 19.8534 6.0135C20.2034 6.36357 20.4001 6.83836 20.4001 7.33343V12.0001"
                      stroke="#D65663"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.8 18.6001H17.2803H15"
                      stroke="#D65663"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.4 23.2999C19.9957 23.2999 22.0999 21.1956 22.0999 18.5999C22.0999 16.0042 19.9957 13.8999 17.4 13.8999C14.8042 13.8999 12.7 16.0042 12.7 18.5999C12.7 21.1956 14.8042 23.2999 17.4 23.2999Z"
                      stroke="#D65663"
                    />
                  </svg>
                </template>
                <template v-else>
                  <template v-if="isTablet">{{ $root.staticText.lk.eventsDelete }}</template>
                  <template v-else>
                    {{ visibleDelete === index ? $root.staticText.lk.eventsDelete : $root.staticText.lk.eventsAdded }}
                  </template>
                </template>
              </a>
            </div>
          </div>
          <div v-if="index === 0" class="t-lk-events__right">
            <div v-if="isMobile" class="t-lk-events__spent">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 3.8002C9.82524 3.8002 7.73953 4.66412 6.20174 6.20192C4.66394 7.73972 3.80001 9.82542 3.80001 12.0002C3.80001 13.077 4.01211 14.1433 4.4242 15.1382C4.83629 16.1331 5.4403 17.037 6.20174 17.7985C6.96318 18.5599 7.86714 19.1639 8.86201 19.576C9.85688 19.9881 10.9232 20.2002 12 20.2002C13.0769 20.2002 14.1431 19.9881 15.138 19.576C16.1329 19.1639 17.0368 18.5599 17.7983 17.7985C18.5597 17.037 19.1637 16.1331 19.5758 15.1382C19.9879 14.1433 20.2 13.077 20.2 12.0002C20.2 9.82542 19.3361 7.73972 17.7983 6.20192C16.2605 4.66412 14.1748 3.8002 12 3.8002ZM5.07037 5.07055C6.90822 3.23269 9.40089 2.2002 12 2.2002C14.5991 2.2002 17.0918 3.23269 18.9297 5.07055C20.7675 6.90841 21.8 9.40107 21.8 12.0002C21.8 13.2871 21.5465 14.5615 21.054 15.7505C20.5615 16.9395 19.8397 18.0198 18.9297 18.9298C18.0196 19.8399 16.9393 20.5617 15.7503 21.0542C14.5613 21.5467 13.287 21.8002 12 21.8002C10.7131 21.8002 9.43871 21.5467 8.24971 21.0542C7.06072 20.5617 5.98038 19.8399 5.07037 18.9298C4.16035 18.0198 3.43849 16.9395 2.94599 15.7505C2.4535 14.5615 2.20001 13.2871 2.20001 12.0002C2.20001 9.40107 3.23251 6.90841 5.07037 5.07055ZM12 7.2002C12.4418 7.2002 12.8 7.55837 12.8 8.0002V11.6688L15.5657 14.4345C15.8781 14.7469 15.8781 15.2535 15.5657 15.5659C15.2533 15.8783 14.7467 15.8783 14.4343 15.5659L11.4343 12.5659C11.2843 12.4159 11.2 12.2124 11.2 12.0002V8.0002C11.2 7.55837 11.5582 7.2002 12 7.2002Z"
                  fill="#00b0bd"
                />
              </svg>
              {{ $root.staticText.lk.eventsLeft }}: {{ item.hour }} {{ $root.staticText.lk.eventsHour }} {{ item.minutes }}
              {{ $root.staticText.lk.eventsMin }}
            </div>
            <div v-else class="t-lk-events-time">
              <div class="t-lk-events-time__subtitle">
                {{ $root.staticText.lk.eventsLeft }}
              </div>
              <div class="t-lk-events-time__item">
                <div class="t-lk-events-time__number">{{ item.hour }}</div>
                <div class="t-lk-events-time__subtext">
                  {{ $root.staticText.lk.eventsHour }}
                </div>
              </div>
              <div class="t-lk-events-time__item">
                <div class="t-lk-events-time__number">{{ item.minutes }}</div>
                <div class="t-lk-events-time__subtext">
                  {{ $root.staticText.lk.eventsMin }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <banner-native-cmp v-if="banner" v-animation:bottom.delay :banner="banner"> </banner-native-cmp>

      <div class="t-lk-events__past-events t-lk-past-events">
        <h2 v-animation:bottom.delay class="t-lk-title t-lk-container-mobile">
          {{ $root.staticText.lk.pastEventsTitle }}
        </h2>
        <div v-animation:bottom.delay class="t-lk-promotions-completed t-lk-events-table">
          <div class="t-lk-promotions-completed__row">
            <lk-search-cmp :obj-undefined="{ currentPagePastEvents: undefined }" :animation="'pastEvents'"> </lk-search-cmp>

            <filter-cmp
              v-if="filterPastEvents"
              class="t-lk-promotions-completed__filter"
              :filter="filterPastEvents"
              :animation="'pastEvents'"
              :obj-undefined="{ currentPagePastEvents: undefined }"
              :name-btn="$root.staticText.lk.eventsFilterBtn"
              :is-date="true"
            >
            </filter-cmp>
          </div>

          <div class="t-lk-promotions-completed-table">
            <div v-animation:bottom.delay class="t-lk-promotions-completed-table__row _first">
              <div class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td" v-for="item in pastEventsTitle">
                {{ item }}
              </div>
            </div>
            <div class="js-past-events">
              <template v-if="pastEvents.length > 0">
                <div v-animation:bottom.delay v-for="item in pastEvents" :key="item.id" class="t-lk-promotions-completed-table__row">
                  <div class="t-lk-promotions-completed-table__td">
                    <div class="t-lk-promotions-completed-table__desc t-lk-events-table__name">
                      {{ item.category }}: {{ item.name }}
                    </div>
                  </div>
                  <div class="t-lk-promotions-completed-table__td">
                    <div class="t-lk-promotions-completed-table__date">{{ item.date }}</div>
                  </div>
                  <div class="t-lk-promotions-completed-table__td">
                    <template v-for="material in item.materials">
                      <a v-if="material.link" :href="material.link" target="”_blank”" class="t-lk-events-table__materials">
                        {{ material.text }}
                      </a>
                      <div
                        v-else-if="material.video"
                        @click="
                          modalType_eventsVideoOpen({
                            class: '_lk',
                            video: material.video,
                            desc: material.description,
                            link: material.linkVideo,
                            date: item.date,
                            title: item.category + ': ' + item.name,
                          })
                        "
                        class="t-lk-events-table__materials"
                      >
                        {{ material.text }}
                      </div>
                      <div
                        v-else
                        @click="
                          modalType_requestOpen({
                            options: optionsRequest,
                            button: $root.staticText.forms.btn,
                          })
                        "
                        class="t-lk-events-table__materials"
                      >
                        {{ material.text }}
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-animation:bottom.delay class="t-lk-events__empty-events">
                  Вы не посещали мероприятия Axoft в данный период времени.
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-if="spentHours" v-animation:bottom.delay class="t-lk-events__spent">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 3.8002C9.82524 3.8002 7.73953 4.66412 6.20174 6.20192C4.66394 7.73972 3.80001 9.82542 3.80001 12.0002C3.80001 13.077 4.01211 14.1433 4.4242 15.1382C4.83629 16.1331 5.4403 17.037 6.20174 17.7985C6.96318 18.5599 7.86714 19.1639 8.86201 19.576C9.85688 19.9881 10.9232 20.2002 12 20.2002C13.0769 20.2002 14.1431 19.9881 15.138 19.576C16.1329 19.1639 17.0368 18.5599 17.7983 17.7985C18.5597 17.037 19.1637 16.1331 19.5758 15.1382C19.9879 14.1433 20.2 13.077 20.2 12.0002C20.2 9.82542 19.3361 7.73972 17.7983 6.20192C16.2605 4.66412 14.1748 3.8002 12 3.8002ZM5.07037 5.07055C6.90822 3.23269 9.40089 2.2002 12 2.2002C14.5991 2.2002 17.0918 3.23269 18.9297 5.07055C20.7675 6.90841 21.8 9.40107 21.8 12.0002C21.8 13.2871 21.5465 14.5615 21.054 15.7505C20.5615 16.9395 19.8397 18.0198 18.9297 18.9298C18.0196 19.8399 16.9393 20.5617 15.7503 21.0542C14.5613 21.5467 13.287 21.8002 12 21.8002C10.7131 21.8002 9.43871 21.5467 8.24971 21.0542C7.06072 20.5617 5.98038 19.8399 5.07037 18.9298C4.16035 18.0198 3.43849 16.9395 2.94599 15.7505C2.4535 14.5615 2.20001 13.2871 2.20001 12.0002C2.20001 9.40107 3.23251 6.90841 5.07037 5.07055ZM12 7.2002C12.4418 7.2002 12.8 7.55837 12.8 8.0002V11.6688L15.5657 14.4345C15.8781 14.7469 15.8781 15.2535 15.5657 15.5659C15.2533 15.8783 14.7467 15.8783 14.4343 15.5659L11.4343 12.5659C11.2843 12.4159 11.2 12.2124 11.2 12.0002V8.0002C11.2 7.55837 11.5582 7.2002 12 7.2002Z"
              fill="#00b0bd"
            />
          </svg>
          {{ spentHours }}
        </div>
        <pagination-cmp
          v-animation:bottom.delay
          v-if="paginationPastEvents"
          :pagination="paginationPastEvents"
          :name-current-page="'currentPagePastEvents'"
          :animation="'pastEvents'"
          class="t-lk-events__pag _lk"
        >
        </pagination-cmp>
      </div>

      <template v-if="photos.length > 0">
        <lk-title-link-cmp
          v-animation:bottom.delay
          class="t-lk-events__photos"
          :title="$root.staticText.lk.photo"
          :link="'/lk/events/photos'"
          :name="$root.staticText.lk.photoAll"
        ></lk-title-link-cmp>

        <div class="t-lk-events-photos js-photos">
          <lk-photos-item-cmp v-animation:bottom.delay v-for="(item, index) in photos" :item="item" :key="'photos-item' + index">
          </lk-photos-item-cmp>
        </div>
        <pagination-cmp
          v-animation:bottom.delay
          v-if="paginationPhotos"
          :pagination="paginationPhotos"
          :name-current-page="'currentPagePhotos'"
          :animation="'photos'"
          class="t-lk-events__pag _lk"
        >
        </pagination-cmp>
      </template>

      <div class="t-lk-events__selection-items">
        <h2 v-animation:bottom.delay class="t-lk-title t-lk-container-mobile">
          {{ $root.staticText.lk.eventsSelection }}
        </h2>
        <filter-cmp
          v-animation:bottom.delay
          v-if="filterSelection"
          class="t-lk-promotions-selection__filter t-lk-events__filter"
          :filter="filterSelection"
          :animation="'selection'"
          :obj-undefined="{ currentPageSelection: undefined }"
          :name-btn="$root.staticText.lk.eventsFilterBtn"
          :white="true"
        >
        </filter-cmp>
        <div class="t-lk-promotions-selection t-lk-events__selection js-selection">
          <template v-if="eventsSelection.length > 0">
            <div v-animation:bottom.delay v-for="item in eventsSelection" :key="item.id" class="t-lk-events__item">
              <div class="t-lk-events__left">
                <div class="t-lk-events__row">
                  <div class="t-lk-events__category">{{ item.category }}</div>
                  <div class="t-lk-events__date">{{ item.date }}</div>
                  <btn-green-cmp
                    v-if="item.isRecommendation"
                    :link="''"
                    :name="$root.staticText.lk.eventsRecommendation"
                    class="t-lk-events__recommendation"
                  >
                  </btn-green-cmp>
                </div>
                <div class="t-lk-events__name t-clamp-3">{{ item.name }}</div>
                <div class="t-lk-events__row _top">
                  <div class="t-lk-events__img">
                    <img v-if="item.img" :src="item.img" alt="" />
                  </div>
                  <router-link :to="item.link" class="t-lk-events__invite">
                    <template v-if="isMobile">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                          stroke="#00b0bd"
                          stroke-width="1.68"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path d="M14 2V8H20" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 18V12" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M9 15H15" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </template>
                    <template v-else>
                      {{ $root.staticText.lk.eventsSelectionBtn }}
                    </template>
                  </router-link>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <p v-animation:bottom.delay class="t-lk-events__empty-events">
              На текущий момент нет запланированных мероприятий.
            </p>
          </template>
        </div>
        <pagination-cmp
          v-animation:bottom.delay
          v-if="paginationSelection"
          :pagination="paginationSelection"
          :name-current-page="'currentPageSelection'"
          :animation="'selection'"
          class="t-lk-promotions-completed__pag _lk"
        >
        </pagination-cmp>
      </div>
    </div>

    <div class="t-lk-events__form">
      <PageForm
        v-if="formConfig"
        v-animation:bottom.delay
        class="t-lk-container"
        action="feedback/send"
        :agreements="[]"
        :form-config="formConfig"
        :success-title="$root.staticText.modal.successTitleReg"
        :success-text="$root.staticText.modal.successText"
        :error-title="$root.staticText.modal.errorTitleReg"
        :error-text="$root.staticText.modal.errorText"
        :submit-label="$root.staticText.forms.btn"
      ></PageForm>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import btnGreen from '@components/lk/btn-green/btn-green.vue'
import titleLink from '@components/lk/lk-title-link/lk-title-link.vue'
import bannerNative from '@components/lk/banner-native/banner-native.vue'
import lkSearch from '@components/lk/lk-search/lk-search.vue'
import filter from '@components/lk/lk-filter/lk-filter.vue'
import pagination from '@components/ui-components/pagination/pagination.vue'
import photosItem from '@components/lk/lk-photos-item/lk-photos-item.vue'
import PageForm from '@shared/ui/public/forms/PageForm.vue'

import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'lk-events',
  data() {
    return {
      visibleDelete: false,

      events: null,
      banner: null,
      optionsRequest: null,
      spentHours: null,
      listDecision: null,

      filterPastEvents: null,
      pastEventsTitle: [
        this.$root.staticText.lk.promotionsCompletedTable,
        this.$root.staticText.lk.promotionsCompletedTable2,
        this.$root.staticText.lk.materials,
        '',
      ],
      pastEvents: [],
      paginationPastEvents: null,

      photos: [],
      paginationPhotos: null,

      filterSelection: null,
      eventsSelection: [],
      paginationSelection: null,

      formConfig: null,
    }
  },
  components: {
    'btn-green-cmp': btnGreen,
    'lk-title-link-cmp': titleLink,
    'banner-native-cmp': bannerNative,
    'lk-search-cmp': lkSearch,
    'filter-cmp': filter,
    'pagination-cmp': pagination,
    'lk-photos-item-cmp': photosItem,
    PageForm,
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  methods: {
    ...mapActions('modal', ['modalType_inviteOpen', 'modalType_requestOpen', 'modalType_eventsVideoOpen']),

    setData(data) {
      this.events = data.events
      this.banner = data.banner
      this.optionsRequest = data.optionsRequest
      this.spentHours = data.spentHours
      this.listDecision = data.listDecision

      this.filterPastEvents = data.filterPastEvents
      this.pastEvents = data.pastEvents
      this.paginationPastEvents = data.paginationPastEvents

      this.photos = data.photos
      this.paginationPhotos = data.paginationPhotos

      this.filterSelection = data.filterSelection
      this.eventsSelection = data.eventsSelection
      this.paginationSelection = data.paginationSelection

      this.formConfig = data.form
    },
  },
  beforeRouteUpdate(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/eventsPage.json' : 'lk/events'

    if (to.query.animation === 'pastEvents') {
      this.$root.setDataAnimateFalse('.js-past-events ')
    } else if (to.query.animation === 'photos') {
      this.$root.setDataAnimateFalse('.js-photos ')
    } else if (to.query.animation === 'selection') {
      this.$root.setDataAnimateFalse('.js-selection ')
    }

    Vue.http.get(url, { params: to.query }).then(
      data => {
        this.setData(data.data)
        next()
        setTimeout(() => {
          onScrollAnimate()
        }, 500)
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
  beforeRouteEnter(to, from, next) {
    let url = process.env.NODE_ENV !== 'production' ? 'lk/eventsPage.json' : 'lk/events'
    Vue.http.get(url, { params: to.query }).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.t-lk-events
  &__form
    margin-top: 64px

    @media (max-width: $mobile-size)
      margin-top: 48px
</style>



// WEBPACK FOOTER //
// src/templates/pages/lk/events/index.vue